/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { CcbSwitchImpl } from './CcbSwitchImpl';
import { ICcbSwitch } from './ICcbSwitch';

export class CcbSwitch {
    private static mCcbSwitchImpl: ICcbSwitch;

    public static getInstance(): ICcbSwitch {
        if (!CcbSwitch.mCcbSwitchImpl) {
            CcbSwitch.mCcbSwitchImpl = new CcbSwitchImpl();
        }
        return CcbSwitch.mCcbSwitchImpl;
    }

    public static setCcbSwitchImpl(ccbSwitchImpl: ICcbSwitch) {
        CcbSwitch.mCcbSwitchImpl = ccbSwitchImpl;
    }
}
